import { Flag, GraduationCap, TrophyIcon } from "lucide-react"; // Importing icons
import React from "react";

const EventCard = ({ icon: Icon, title, date, description }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 max-w-sm h-54 relative">
    <div className="flex justify-center ">
      <Icon className="w-12 h-12 text-tomato" />
    </div>

    {/* Title limited to 1 line with truncation */}
    <h3 className="text-xl font-semibold mb-1 text-center truncate">{title}</h3>

    {/* Date limited to 1 line with truncation */}
    <p className="text-gray-500 text-sm text-center truncate">{date}</p>

    {/* Description limited to 3 lines with truncation */}
    <p className="text-gray-600 text-center line-clamp-3 overflow-hidden">
      {description}
    </p>
  </div>
);

const FrequentEvents = () => (
  <section className="py-20 bg-gray-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-4xl font-bold text-center text-indigo-700">
       Gam-Ind Frequent Events
      </h2>
      <p className="text-lg text-center text-gray-600 mb-12">
        Join us for these exciting opportunities
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <EventCard
          title="Gambia Independence Celebration"
          date="February 18, 2025"
          description="Celebrate Gambian Independence with traditional music, dance, and networking."
          icon={Flag} // Using the imported icon
        />
        <EventCard
          title="Inter-State Championship"
          date="October 5, 2024"
          description="Learn and Participate to boost your talent."
          icon={TrophyIcon} // Using the imported icon
        />
        <EventCard
          title="Student Week & Graduations"
          date="June 29, 2025"
          description="A platform for academic achievements celebration, cultural exchange and fostering bilateral relations"
          icon={GraduationCap} // Using the imported icon
        />
      </div>
    </div>
  </section>
);

export default FrequentEvents;
